import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'reactstrap';
import SearchUser from './../../common/ui/SearchUser';
import Close from './../../common/ui/Close';

export default class StartConversationModal extends Component {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    workersPredictionsList: PropTypes.array.isRequired,
    closeModal: PropTypes.func.isRequired,
    startNewConversation: PropTypes.func.isRequired,
    searchAction: PropTypes.func.isRequired,
    onBlurAction: PropTypes.func.isRequired
  };

  state = {
    selectedUser: null
  };

  handleChangeUser = selectedUser => {
    this.setState({ selectedUser });
  };

  cancelSelect = () => {
    this.setState({
      selectedUser: null
    });
    this.props.closeModal();
  };

  submitSelect = () => {
    const { startNewConversation } = this.props;
    const { selectedUser } = this.state;
    if (selectedUser) {
      startNewConversation(selectedUser.userData);
    }
  };

  render () {
    const { selectedUser } = this.state;
    const { isOpen, closeModal, workersPredictionsList, onBlurAction, searchAction } = this.props;
    return (
      <Modal isOpen={isOpen} centered>
        <div className='modal-header'>
          <div className='modal-title'>Start Conversation</div>
          <Close onClick={closeModal} />
        </div>

        <div className='modal-body'>
          <SearchUser
            predictionsList={workersPredictionsList}
            searchAction={searchAction}
            onBlurAction={onBlurAction}
            selectedUser={selectedUser}
            handleChangeUser={this.handleChangeUser}
          />
          <div className='d-flex justify-content-end w-100'>
            <button
              className='button button-cancel'
              onClick={this.cancelSelect}
            >
              Cancel
            </button>
            <button
              className='button button-primary ml-3'
              onClick={this.submitSelect}
            >
              Start Conversation
            </button>
          </div>
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/messages/StartConversationModal.js